/** 1234 → "$12.34" in the payment's currency (amounts are integer cents). */
export const formatMoney = (cents, currency = 'cad') =>
  new Intl.NumberFormat('en-CA', { style: 'currency', currency: currency.toUpperCase() }).format((cents || 0) / 100);
